<nz-modal
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzFooter]="null"
  [nzWidth]="'80vw'"
  [nzMaskClosable]="false"
  nzWrapClassName="workbench-view-modal-wrap"
  (nzOnCancel)="onClose()"
>
  <ng-container *nzModalContent>
    <ng-container *ngIf="row as selectedRow">
      <div class="workbench-view-modal">
        <div class="details-grid">
          <div>
            <span nz-typography class="nfl-form-label">Query Name</span>
            <span>{{ selectedRow.queryName }}</span>
          </div>
          <div>
            <span nz-typography class="nfl-form-label">Query Status</span>
            <span>
              <nz-tag [nzColor]="getStatusColor(selectedRow.status)">{{ getDisplayStatus(selectedRow.status) }}</nz-tag>
            </span>
          </div>
          <div *ngIf="isSchedulerSource">
            <span nz-typography class="nfl-form-label">Scheduler Name</span>
            <span>{{ selectedRow.schedulerName || '-' }}</span>
          </div>
          <div>
            <span nz-typography class="nfl-form-label">Modified By</span>
            <span>{{ selectedRow.lastModifiedBy }}</span>
          </div>
          <div *ngIf="isSchedulerSource">
            <span nz-typography class="nfl-form-label">Ran On</span>
            <span>{{ selectedRow.lastModifiedAt | dateTime }}</span>
          </div>
          <div [class]="descriptionRowClass">
            <span nz-typography class="nfl-form-label">Query Description</span>
            <span>{{ queryRecord?.queryDescription?.trim() || '-' }}</span>
          </div>
        </div>

        <nz-tabset class="detail-tabs">
          <nz-tab nzTitle="Query">
            <ng-template nz-tab>
              <div *ngIf="isLoading; else queryTabContent" class="query-tab-loader">
                <nz-spin nzSpinning="true" nzSize="large"></nz-spin>
              </div>

              <ng-template #queryTabContent>
                <div class="query-tab-content">
                  <div class="query-view-panel">
                    <app-monaco-editor [value]="queryText" [readOnly]="true"> </app-monaco-editor>
                  </div>

                  <div class="validation-logs-panel" *ngIf="queryRecord?.validationLogs">
                    <p nz-typography class="nfl-form-label">Validation Logs</p>
                    <p nz-typography [nzType]="validationSummaryType">
                      {{ validationSummaryMessage }}
                    </p>

                    <ng-container *ngIf="validationLogs?.warnings?.length || 0">
                      <p nz-typography>Warnings</p>
                      <div *ngFor="let warning of validationLogs?.warnings" class="validation-log-entry">
                        <p nz-typography nzType="warning">
                          {{ warning }}
                        </p>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="validationLogs?.errors?.length || 0">
                      <p nz-typography>Errors</p>
                      <div *ngFor="let error of validationLogs?.errors" class="validation-log-entry">
                        <p nz-typography nzType="danger">
                          {{ error }}
                        </p>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
            </ng-template>
          </nz-tab>
          <nz-tab *ngIf="isExecutedQuery" nzTitle="Results">
            <ng-template nz-tab>
              <div class="results-view-panel">
                <app-workbench-query-result [queryRecord]="resultQueryRecord"></app-workbench-query-result>
              </div>
            </ng-template>
          </nz-tab>
        </nz-tabset>
      </div>
    </ng-container>
  </ng-container>
</nz-modal>
